import { IDeviceLogItem } from '@/services/api/api.type';

import { formatDate } from 'utils';

type TFormatListParams = {
	total: number;
	page: number;
	pageSize: number;
};

export const formatDeviceLogDetail = (
	input: IDeviceLogItem,
	index: number,
	params: TFormatListParams
) => {
	return {
		...input,
		no: params.total - (params.page - 1) * params.pageSize - index,
		createdAt: formatDate(input.registDt),
	};
};

export const formatDeviceLogList = (
	input: IDeviceLogItem[],
	params: TFormatListParams
) => {
	return input.map((item, index) => formatDeviceLogDetail(item, index, params));
};
